import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCabGastoTropa = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'cab_gasto_tropa',
        name: 'Registro Gastos por Tropa',
        component: ViewCabGastoTropa,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
